import { render, staticRenderFns } from "./forms.vue?vue&type=template&id=c2275302&"
import script from "./forms.ts?vue&type=script&lang=ts&"
export * from "./forms.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports